import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private count = 0;

    constructor(private loaderService: LoaderService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        /**
         * TODO: fix me
         * Evita loading se intenção é só carregar os filtros
         */
        const params = new URLSearchParams(req.body);
        if (params.get('loadAll') === '0') return next.handle(req);

        if (this.count === 0) {
            setTimeout(() => {
                this.loaderService.setHttpProgressStatus(true);
            }, 0);
        }
        this.count++;
        return next.handle(req).pipe(
            finalize(() => {
                this.count--;
                if (this.count === 0) {
                    setTimeout(() => {
                        this.loaderService.setHttpProgressStatus(false);
                    }, 0);
                }
            })
        );
    }
}
